import * as React from "react";

function SvgCalendarIconSmall(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={17}
      height={17}
      {...props}
    >
      <defs>
        <path
          d="M4.13 9.11c.67 0 1.21-.55 1.21-1.22 0-.67-.54-1.21-1.21-1.21-.67 0-1.22.54-1.22 1.21 0 .67.55 1.22 1.22 1.22"
          id="calendar-icon-small_svg__a"
        />
        <path
          d="M8.5 9.11c.67 0 1.21-.55 1.21-1.22 0-.67-.54-1.21-1.21-1.21-.67 0-1.21.54-1.21 1.21 0 .67.54 1.22 1.21 1.22"
          id="calendar-icon-small_svg__b"
        />
        <path
          d="M12.87 9.11c.67 0 1.22-.55 1.22-1.22 0-.67-.55-1.21-1.22-1.21-.67 0-1.21.54-1.21 1.21 0 .67.54 1.22 1.21 1.22"
          id="calendar-icon-small_svg__c"
        />
        <path
          d="M4.13 10.32c-.67 0-1.22.54-1.22 1.22 0 .67.55 1.21 1.22 1.21.67 0 1.21-.54 1.21-1.21 0-.68-.54-1.22-1.21-1.22"
          id="calendar-icon-small_svg__d"
        />
        <path
          d="M8.5 12.75c.67 0 1.21-.54 1.21-1.21a1.21 1.21 0 10-2.42 0c0 .67.54 1.21 1.21 1.21"
          id="calendar-icon-small_svg__e"
        />
        <path
          d="M12.87 12.75c.67 0 1.22-.54 1.22-1.21 0-.68-.55-1.22-1.22-1.22-.67 0-1.21.54-1.21 1.22 0 .67.54 1.21 1.21 1.21"
          id="calendar-icon-small_svg__f"
        />
        <path
          d="M0 1.21v14.58h17V1.21H0zm15.54 13.12H1.46V4.61h14.08v9.72z"
          id="calendar-icon-small_svg__g"
        />
      </defs>
      <use xlinkHref="#calendar-icon-small_svg__a" fill="#dedede" />
      <use
        xlinkHref="#calendar-icon-small_svg__a"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <use xlinkHref="#calendar-icon-small_svg__b" fill="#dedede" />
      <use
        xlinkHref="#calendar-icon-small_svg__b"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <use xlinkHref="#calendar-icon-small_svg__c" fill="#dedede" />
      <use
        xlinkHref="#calendar-icon-small_svg__c"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <use xlinkHref="#calendar-icon-small_svg__d" fill="#dedede" />
      <use
        xlinkHref="#calendar-icon-small_svg__d"
        fillOpacity={0}
        stroke="#000"
        strokeOpacity={0}
      />
      <g>
        <use xlinkHref="#calendar-icon-small_svg__e" fill="#dedede" />
        <use
          xlinkHref="#calendar-icon-small_svg__e"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
      <g>
        <use xlinkHref="#calendar-icon-small_svg__f" fill="#dedede" />
        <use
          xlinkHref="#calendar-icon-small_svg__f"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
      <g>
        <use xlinkHref="#calendar-icon-small_svg__g" fill="#dedede" />
        <use
          xlinkHref="#calendar-icon-small_svg__g"
          fillOpacity={0}
          stroke="#000"
          strokeOpacity={0}
        />
      </g>
    </svg>
  );
}

export default SvgCalendarIconSmall;
